/**
 * Payments & Billing API Service
 *
 * Handles all payment-related API calls:
 * - Manual payments
 * - M-Pesa integration (STK Push, B2C)
 * - Payment confirmation
 * - Bank statement uploads
 */

import {post, get, uploadFile} from './client';

export const paymentsApi = {
    /**
     * Record manual payment
     * @param {Object} paymentData
     * @param {string} paymentData.TransactionType - Type of transaction
     * @param {string} paymentData.TransID - Transaction ID
     * @param {string} paymentData.TransTime - Transaction time
     * @param {number} paymentData.TransAmount - Transaction amount
     * @param {string} paymentData.BusinessShortCode - Business code
     * @param {string} paymentData.BillRefNumber - Bill reference
     * @param {string} paymentData.MSISDN - Phone number
     * @param {string} paymentData.FirstName - Customer name
     * @param {string} paymentData.tenant_id - Tenant ID
     * @param {string} paymentData.landlord_id - Landlord ID
     * @returns {Promise<Object>} Payment recording response
     */
    recordPayment: async (paymentData) => {
        return post('pegasus/visionary/payments/', paymentData);
    },

    /**
     * Initiate M-Pesa STK Push for subscription
     * @param {Object} stkData
     * @param {string} stkData.BusinessShortCode - Business short code
     * @param {string} stkData.Password - Encoded password
     * @param {string} stkData.Timestamp - Timestamp
     * @param {string} stkData.TransactionType - Transaction type
     * @param {number} stkData.Amount - Amount to pay
     * @param {string} stkData.PartyA - Customer phone
     * @param {string} stkData.PartyB - Business short code
     * @param {string} stkData.PhoneNumber - Customer phone
     * @param {string} stkData.CallBackURL - Callback URL
     * @param {string} stkData.AccountReference - Account reference
     * @param {string} stkData.TransactionDesc - Description
     * @param {string} stkData.landlord_id - Landlord ID
     * @returns {Promise<Object>} STK Push response
     */
    mpesaStkPush: async (stkData) => {
        return post('pegasus/visionary/mpesa/landlord/StkPush', stkData);
    },

    /**
     * Confirm M-Pesa payment
     * @param {Object} confirmData
     * @param {string} confirmData.transaction_code - Transaction code
     * @param {string} confirmData.property_id - Property ID
     * @returns {Promise<Object>} Confirmation response
     */
    confirmMpesaPayment: async (confirmData) => {
        return post('pegasus/visionary/mpesa/Confirm/Payment', confirmData);
    },

    /**
     * Get supported banks for bank statement upload
     * @returns {Promise<Object>} List of supported banks
     */
    getSupportedBanks: async () => {
        return get('pegasus/visionary/payments/supported-banks');
    },

    /**
     * Upload bank statement for payment reconciliation
     * @param {FormData} formData - Form data with bank statement file
     * @returns {Promise<Object>} Upload response
     */
    uploadBankStatement: async (formData) => {
        return uploadFile('pegasus/visionary/payments/bank-statement', formData);
    },
};

export default paymentsApi;
